document.addEventListener("DOMContentLoaded", function () {
	//Configure animations based on BEM class names (i.e. background-banner__text will recieve data-animation-name="b2t")
	const animationConfig = {
		"background-banner": {
			text: "b2t",
			arrow: "t2b"
		},
		"card-story": {
			content: "l2r",
			media: "r2l"
		},
		"grid_h_cards": {
			text: "l2r",
			image: "r2l"
		},
		"grid-h-cards-header": {
			text: "l2r",
			"image-wrapper": "r2l"
		},
		"section-header": {
			title: "l2r",
			body: "b2t",
			link: "r2l"
		},
		"banner": {
			image: "l2r",
			content: "r2l"
		}
	};
	//Active animations when element is in the viewport
	const intersectionObserver = new IntersectionObserver(
		(entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.dataset.animationName = "off";
					observer.unobserve(entry.target); //no need to observe once the animation is played
				}
			});
		}
	);

	//Set animations
	document.querySelectorAll("[data-animation]").forEach((element) => {
		const animationType = element.dataset.animation;
		switch (element.dataset.animation) {
			case "cards":
				const cards = element.querySelectorAll('.card, .card-icon, .card-category');
				let animations = ["l2r", "b2t", "r2l"];

				if (element.classList.contains('grid--all_articles')) {
					animations = [
						"l2r", "b2t", "r2l", 
						"l2r", "r2l", 
						"l2r", "r2l" ,
						"l2r", "b2t", "r2l"
					];
				}


				switch (cards.length) {
					case 1:
					case 2:
					case 4:
					// case 8:
					// case 10:
						animations = ["l2r", "r2l"];
					break;
				}

				Array.from(cards).forEach((card, idx) => {
					card.dataset.animationName = animations[idx%animations.length];
					intersectionObserver.observe(card);
				});
			break;

			default:
				//Let's set animation based on BEM classnames
				let config = animationConfig[animationType];

				if (config) {
					Object.keys(config).forEach((field) => {
						//BEM class (i.e. section-header__body)
						const el = element.getElementsByClassName(`${animationType}__${field}`);

						if (el.length > 0) {
							el[0].dataset.animationName = config[field];

							intersectionObserver.observe(el[0]);
						}
					});
				}
			break;
		}
	});
});